import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function generatePaymentReceiptPdf(client, payment, paymentsHistory = [], brandName = "Groupfie Studio") {
  const doc = new jsPDF();
  const primaryColor = [20, 39, 81]; // #142751 (Blue)

  // 1. Header Bar with Brand Name
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, 210, 28, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(`${brandName.toUpperCase()} — PAYMENT RECEIPT`, 14, 18);

  // 2. Receipt & Client Info
  doc.setTextColor(50, 50, 50);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  const receiptDate = payment.date_of_payment
    ? new Date(payment.date_of_payment).toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : new Date().toLocaleDateString();

  doc.text(`Client Name: ${client.name || "N/A"}`, 14, 38);
  doc.text(`Contact Phone: ${client.contact_phone || "N/A"}`, 14, 44);
  doc.text(`Contact Email: ${client.contact_email || "N/A"}`, 14, 50);

  doc.text(`Receipt ID: #${payment.id?.slice(0, 8) || "N/A"}`, 135, 38);
  doc.text(`Payment Date: ${receiptDate}`, 135, 44);
  doc.text(`Payment Mode: ${payment.payment_mode || "Cash"}`, 135, 50);

  // Divider Line
  doc.setDrawColor(220, 220, 220);
  doc.line(14, 56, 196, 56);

  // 3. Current Payment Acknowledgment
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(37, 99, 235);
  doc.text("Payment Received", 14, 65);

  const currentPaymentRow = [
    [
      `Rs ${(payment.amount_received || 0).toLocaleString()}`,
      payment.payment_mode || "Cash",
      receiptDate,
      payment.note || "N/A"
    ]
  ];

  autoTable(doc, {
    startY: 70,
    head: [["Amount Received", "Payment Mode", "Date", "Note"]],
    body: currentPaymentRow,
    headStyles: { fillStyle: "F", fillColor: primaryColor, textColor: 255 },
    styles: { fontSize: 10, fontStyle: "bold" },
  });

  let lastY = doc.lastAutoTable.finalY + 12;

  // 4. Financial Summary Calculation
  const totalCommitted = client.package?.total_committed_amount || 0;
  const totalReceivedSoFar = paymentsHistory.reduce((s, p) => s + (p.amount_received || 0), 0);
  const remainingBalance = Math.max(0, totalCommitted - totalReceivedSoFar);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(50, 50, 50);
  doc.text("Account & Balance Summary", 14, lastY);

  const summaryRows = [
    ["Total Committed Amount", `Rs ${totalCommitted.toLocaleString()}`],
    ["Total Amount Received To Date", `Rs ${totalReceivedSoFar.toLocaleString()}`],
    ["Remaining Balance Due", `Rs ${remainingBalance.toLocaleString()}`],
  ];

  autoTable(doc, {
    startY: lastY + 5,
    body: summaryRows,
    theme: "plain",
    styles: { fontSize: 10, cellPadding: 2.5 },
    columnStyles: {
      0: { fontStyle: "bold", cellWidth: 70 },
      1: { cellWidth: 110, fontStyle: "bold" },
    },
  });

  lastY = doc.lastAutoTable.finalY + 12;

  // 5. Complete Payment Ledger / History
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Payment History Ledger", 14, lastY);

  const historyRows = (paymentsHistory || []).map((p, idx) => [
    `#${idx + 1}`,
    p.date_of_payment ? new Date(p.date_of_payment).toLocaleDateString() : "—",
    p.payment_mode || "Cash",
    p.note || "—",
    `Rs ${(p.amount_received || 0).toLocaleString()}`,
  ]);

  autoTable(doc, {
    startY: lastY + 4,
    head: [["Sl", "Date", "Mode", "Note", "Amount"]],
    body: historyRows,
    theme: "grid",
    headStyles: { fillStyle: "F", fillColor: [240, 240, 240], textColor: 50, fontStyle: "bold" },
    styles: { fontSize: 8.5, cellPadding: 2 },
    columnStyles: {
      0: { cellWidth: 15 },
      1: { cellWidth: 35 },
      2: { cellWidth: 35 },
      3: { cellWidth: 60 },
      4: { cellWidth: 35, fontStyle: "bold" },
    },
  });

  lastY = doc.lastAutoTable.finalY + 14;

  // 6. Footer Note
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(120, 120, 120);
  doc.text(
    `Thank you for your payment to ${brandName}! This is a computer-generated receipt.`,
    14,
    lastY
  );

  // Save PDF
  const sanitizedFilename = (client.name || "client")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "_");
  doc.save(`Receipt_${sanitizedFilename}_${receiptDate.replace(/\s+/g, "_")}.pdf`);
}